
import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import { ReactNode } from "react";

interface LoginRouteGuardProps {
  children: ReactNode;
}

const LoginRouteGuard = ({ children }: LoginRouteGuardProps) => {
  const { user, loading } = useAuth();

  // Se è in corso il caricamento, mostra la schermata di loading
  if (loading) {
    return <></>;
  }

  // Se l'utente è già autenticato, reindirizza alla dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // Se l'utente non è autenticato, mostra la pagina di login
  return <>{children}</>;
};

export default LoginRouteGuard;
